import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalInformation } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function FreemiumFlowOffToOnUsingFreeDone(props) {
  const { onClickAction, isInmobiliaria, hasAvailableItems } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `Republicar Aviso_${hasAvailableItems ? 'Con credito' : 'Sin credito'}_Activar Gratis_${
      isInmobiliaria ? 'Inmobiliaria' : 'Particular'
    }-Exito`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.FreemiumFlowOffToOnUsingFreeDone.title')}
      message={t('panel.modal.FreemiumFlowOffToOnUsingFreeDone.subtitle')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { FreemiumFlowOffToOnUsingFreeDone };
